// assets
import { Github, Linkedin, EnvelopeFill, Whatsapp } from "react-bootstrap-icons";

export const websites = [
    {
      textKey: "contact.linkedin",
      icon: <Linkedin size="1rem" />,
      url: "https://www.linkedin.com/in/mirian-arevalo",
    },
    {
      textKey: "contact.github",
      icon: <Github size="1rem" />,
      url: "https://github.com/mirianalejandra1996",
    },
    {
      textKey: "contact.email",
      icon: <EnvelopeFill size="1rem" />,
      url: "mailto:mirianalejandra1996@gmail.com",
    },
    {
      textKey: "contact.whatsapp",
      icon: <Whatsapp size="1rem" />,
      url: "https://wa.me/51933014855",
    },
  ];
